import React, { useEffect, useState } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';

// Fallback Assets
import introBuilding from '../../assets/images/IMG_2430.jpg';
import buddhaImg from '../../assets/images/BudhhaCrop.jpg';
import certificateImg from '../../assets/images/Certificate-NR.jpeg';
import gallery1 from '../../assets/images/Workshopcopysize.jpg';
import gallery2 from '../../assets/images/Workshop1.JPG';
import gallery3 from '../../assets/images/Workshop2.JPG';
import gallery4 from '../../assets/images/workshop3.JPG';
import gallery5 from '../../assets/images/Farming.jpg';
import gallery6 from '../../assets/images/Farms1.JPG';

const Intro = () => {
  const [media, setMedia] = useState({});
  const fallbacks = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const res = await API.get('get-content/Introduction/');
        setMedia(res.data);
      } catch (err) {
        console.error("Error loading media:", err);
      }
    };
    fetchMedia();
  }, []);

  
  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };

  
  const getEmbedUrl = (url) => {
    if (!url) return "https://www.youtube.com/embed/ZT_OnXNdYfg";
    if (url.includes('embed/')) return url;
    try {
      const videoId = url.split('v=')[1] || url.split('/').pop();
      return `https://www.youtube.com/embed/${videoId.split('&')[0]}`;
    } catch { return "https://www.youtube.com/embed/ZT_OnXNdYfg"; }
  };

  return (
    <div className="bg-white">
      <SubPageHeader title="Introduction" subtitle="The Global School of Happiness" />

      <div className="font-serif text-[#555]">
        <section className="py-20 container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-4xl text-[#333] mb-6 font-light italic">Introduction</h2>
            <p className="text-lg leading-relaxed mb-4" style={{ fontFamily: "'Viner Hand ITC', cursive", color: "#032167", fontStyle: "normal" }}>
              Jai Gurudeo ! Hari Aum!
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <div className="p-4 border border-gray-100 shadow-sm bg-white">
                <img src={resolveImageUrl(media.intro_building, introBuilding)} alt="TGSOH" className="w-full h-auto transition-all duration-700" />
              </div>
            </div>
            <div className="md:w-1/2 space-y-6 text-lg leading-relaxed text-justify">
              <p><span className="font-bold text-[#1e3a8a]">"THE GLOBAL SCHOOL OF HAPPINESS"</span> - as the name indicates is an institution committed to spread happiness to souls across the globel.</p>
              <p>The Global School of Happiness (TGSOH) family believes in the principle of <span className="font-bold">"VASUDHAIV KUTUMBAKAM"</span> meaning - THE WORLD IS ONE.</p>
              <p>Every individual who embraces the TGSOH family is called a <span className="font-bold">HAPPINESS AMBASSADOR</span> and is committed to spread happiness in all walks of his or her life.TGSOH family accommodates everyone irrespective of caste, creed, sex, occupation and location.</p>
              <p>Different courses, workshops and programmes are arranged by TGSOH to enable its family members to "Live life with a Design & Not by default".</p>
            </div>
          </div>
        </section>

        <section className="py-24 bg-[#1a365d] text-white">
          <div className="container mx-auto px-6 flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-2/3 space-y-6 text-lg leading-8 font-normal text-white/90">
              <h2 className="text-3xl font-light uppercase tracking-widest border-b border-white/20 pb-4">Why be a Happiness Ambassador</h2>
              <p className="font-bold text-xl uppercase text-[#29abe2]">Together lets SPREAD HAPPINESS</p>
              <p>The ultimate aim of every individual on this planet is to be "HAPPY."( there is a big difference in being successful and being HAPPY)</p>
              <p>The answer for happiness for most of us is money, materialistic gains, sex, power etc. Therefore, upon research of different coaches' theories, our ancient Indian literature- The Global School of Happiness(TGSOH) has come up with a consolidated comprehensive program to enhance the HAPPINESS INDEX of every soul of its family.</p>
              <p>TGSOH focuses on every individuals dreams and pursuit of happiness in a customized way. Though Happiness parameters are same for everyone, the gravity or intensity may vary from person to person. The common thing for every person on this planet is that -we all have 24 hours in a day to be successful and live our dream life for the ultimate goal of HAPPINESS. It is this efficient utilization of every second of the available 24 hours which lead us to our current and future status.</p> 
              <p>The Happiness ambassadors ensure with different proven tools and techniques to make every moment of their life and their surroundings "HAPPY"</p>
              <p>We believe that everyone can live a happy life forever, but with the proper knowledge and the purpose of ones existence in this world. We welcome every soul irrespective of the boundaries of countries, caste creed sex, education and age.</p>
              <p>Together lets SPREAD HAPPINESS!</p>
              
            </div>
            <div className="md:w-1/3">
              <div className="bg-white/10 p-4 rounded-full border-2 border-white/20">
                <img src={resolveImageUrl(media.buddha_img, buddhaImg)} alt="Meditation" className="w-full h-auto rounded-full shadow-2xl" />
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-[#f9f9f9]">
          <div className="container mx-auto px-6 flex flex-col md:flex-row items-center gap-16">
            <div className="md:w-1/3">
              <div className="border-[15px] border-white shadow-xl">
                <img src={resolveImageUrl(media.certificate_img, certificateImg)} alt="Certificate" className="w-full h-auto" />
              </div>
            </div>
            <div className="md:w-2/3">
              <h3 className="text-4xl text-[#333] font-light mb-8 italic uppercase tracking-wider">
                {media.youtube_title || "Dive In World's Deepest Pool"}
              </h3>
              <div className="relative w-full overflow-hidden rounded shadow-2xl border-4 border-white" style={{ paddingTop: '56.25%' }}>
                <iframe className="absolute top-0 left-0 w-full h-full" src={getEmbedUrl(media.youtube_link)} title="YouTube" allowFullScreen></iframe>
              </div>
              <p className="text-xl font-medium leading-relaxed text-[#1a365d] mt-8 italic">
                {media.youtube_caption ? media.youtube_caption : "MISSION2022~ Successfully dived with my buddy owee in the world's deepest pool which is 60m deep @ DEEP DIVE DUBAI CENTRE"}
              </p>
            </div>
          </div>
        </section>

        <section className="py-20 container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-start gap-12">
            <div className="md:w-1/2 grid grid-cols-3 gap-3">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="border-4 border-gray-50 shadow-sm overflow-hidden group">
                  <img src={resolveImageUrl(media[`gallery_${i}`], fallbacks[i-1])} alt="Gallery" className="w-full h-32 object-cover" />
                </div>
              ))}
            </div>
            <div className="md:w-1/2 text-right">
              <h3 className="text-3xl font-light uppercase tracking-[4px] mb-10 text-[#1a365d]">TGSOH EMPOWERS YOU TO</h3>
              <ul className="space-y-4 text-sm uppercase tracking-widest opacity-70">
                <li>LIVE IN A HAPPY COMMUNITY</li>
                <li>MAKE PASSION YOUR PROFESSION</li>
                <li>BE HEALTHY WEALTHY SPIRITUAL</li>
                <li>BE A NATURE WORSHIPPER</li>
                <li>TRUSTWORTHY AND TRANSPARENT ENVIRONMENT</li>
                <li>TO BE THE PLACEBO FOR YOUR FAMILY AND FRIENDS</li>
                <li>GAIN CONTROL OVER YOUR EMOTIONS AND WORDS</li>
                <li>NO NEGATIVITY</li>
                <li>NO GOSSIPING</li>
                <li>NO VICES</li>
                <li>LIVE LIFE THE YOGIC WAY</li>
                <li>LEARN THE ART OF MUDRAS</li>
                <li>SPREAD HAPPINESS</li>
                <li>BE A HAPPINESS AMBASSADOR</li>

              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Intro;